<div class="modal-header">
    <h4 class="modal-title">Create Purchase Order</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()" [disabled]="isSaving"></button>
</div>
<div class="modal-body">
    <p class="text-muted mb-3">
        Selected parts are grouped by suggested vendor (filter brand). Assign a Vista vendor to each group and a work order item
        to each line, then create one draft purchase order per group. Suggested vendor is a brand label, not a vendor account.
    </p>

    @if (workOrderItems.length === 0) {
        <div class="alert alert-warning py-2">
            This work order has no line items. A work order item is required on every purchase order line.
        </div>
    }

    @if (groups.length === 0) {
        <p>No parts selected.</p>
    }

    @for (group of groups; track group.id) {
        <div class="card mb-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <strong>{{ group.suggestedVendor }}</strong>
                <span class="text-muted">{{ group.lines.length }} line(s) · {{ groupTotal(group) | currency }}</span>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4 mb-2">
                        <label class="form-label">Vendor</label>
                        <select class="form-select" [(ngModel)]="group.vendor" (ngModelChange)="onVendorChange(group)" [name]="'vendor-' + group.id">
                            <option [ngValue]="undefined">Select vendor...</option>
                            @for (vendor of vendors; track vendor.vendorId) {
                                <option [ngValue]="vendor.vendorId">{{ vendor.vendorName }}</option>
                            }
                        </select>
                    </div>
                    <div class="col-md-3 mb-2">
                        <label class="form-label">Required by</label>
                        <input type="date" class="form-control" [(ngModel)]="group.requiredByDate" [name]="'required-' + group.id" />
                    </div>
                    <div class="col-md-5 mb-2">
                        <label class="form-label">Notes</label>
                        <input type="text" class="form-control" [(ngModel)]="group.notes" [name]="'notes-' + group.id" />
                    </div>
                </div>

                <table class="table table-sm mt-2">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Description</th>
                            <th>UOM</th>
                            <th>Qty</th>
                            <th>Unit Price</th>
                            <th>Total</th>
                            <th>WO Item</th>
                            <th>EM CT</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (line of group.lines; track line.id; let i = $index) {
                            <tr>
                                <td>
                                    <input class="form-control form-control-sm" [(ngModel)]="line.itemCode" [name]="'code-' + line.id" />
                                </td>
                                <td>
                                    <input class="form-control form-control-sm" [(ngModel)]="line.description" [name]="'desc-' + line.id" />
                                </td>
                                <td style="width: 80px">
                                    <input class="form-control form-control-sm" [(ngModel)]="line.uom" [name]="'uom-' + line.id" />
                                </td>
                                <td style="width: 90px">
                                    <input
                                        type="number"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="line.quantity"
                                        [name]="'qty-' + line.id"
                                    />
                                </td>
                                <td style="width: 110px">
                                    <input
                                        type="number"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="line.unitPrice"
                                        [name]="'price-' + line.id"
                                    />
                                </td>
                                <td>{{ lineTotal(line) | currency }}</td>
                                <td style="width: 200px">
                                    <select
                                        class="form-select form-select-sm"
                                        [(ngModel)]="line.workOrderItem"
                                        [name]="'woitem-' + line.id"
                                        [disabled]="workOrderItems.length === 0"
                                    >
                                        <option [ngValue]="undefined">Select item...</option>
                                        @for (item of workOrderItems; track item.woitem) {
                                            <option [ngValue]="item.woitem">{{ item.woitem }} — {{ item.description }}</option>
                                        }
                                    </select>
                                </td>
                                <td style="width: 160px">
                                    <select class="form-select form-select-sm" [(ngModel)]="line.emCostType" [name]="'emct-' + line.id">
                                        <option [ngValue]="undefined">—</option>
                                        @for (ct of emCostTypes; track ct.costType) {
                                            <option [ngValue]="ct.costType">{{ ct.costType }} - {{ ct.description }}</option>
                                        }
                                    </select>
                                </td>
                                <td class="text-nowrap">
                                    <select
                                        class="form-select form-select-sm d-inline-block"
                                        style="width: 150px"
                                        (change)="moveLine(group, i, $any($event.target).value); $any($event.target).value = ''"
                                    >
                                        <option value="">Move to...</option>
                                        @for (other of otherGroups(group); track other.id) {
                                            <option [value]="other.id">{{ other.suggestedVendor }}</option>
                                        }
                                        <option value="__new__">New group</option>
                                    </select>
                                    <button type="button" class="btn btn-sm btn-outline-danger ms-1" (click)="removeLine(group, i)">
                                        Drop
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!canCreate">
        {{ isSaving ? 'Creating...' : 'Create Draft PO(s)' }}
    </button>
</div>
